import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Header from "./components/Header";
import HomePage from "./pages/HomePage";
import GalleryPage from "./pages/GalleryPage";
import ColorsPage from "./pages/ColorsPage";
import ErrorBoundary from "./components/ErrorBoundary";
import ScrollToTop from "./components/ScrollToTop";
import AccessibilityWidget from "./components/AccessibilityWidget";
import WhatsAppButton from "./components/WhatsAppButton";

function App() {
  return (
    <ErrorBoundary>
      <div className="App" dir="rtl">
        <a href="#main-content" className="skip-link">דילוג לתוכן הראשי</a>
        <BrowserRouter>
          <ScrollToTop />
          <Header />
          <main id="main-content" role="main">
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/gallery/:category" element={<GalleryPage />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/colors" element={<ColorsPage />} />
            </Routes>
          </main>
          <AccessibilityWidget />
          <WhatsAppButton />
        </BrowserRouter>
      </div>
    </ErrorBoundary>
  );
}

export default App;